// extracted by mini-css-extract-plugin
module.exports = {"PageContainer":"pageContainer-module--PageContainer--eKinl"};